'use client';

import { useEffect, useRef } from "react"

export default function DemoVideo({className, speed, muted = true}: {className?: string, speed?: number, muted?: boolean}) {
    const videoRef = useRef<HTMLVideoElement>(null);
    
    useEffect(() => {
        if (videoRef.current && speed) {
            videoRef.current.playbackRate = speed;
        }
    }, [])

    return (
        <video ref={videoRef} className={`pointer-events-none ${className}`} src={"/vid/theorom-demo-2.mp4"} loop muted={muted}
            autoPlay
            playsInline
            disablePictureInPicture
            controlsList="nodownload nofullscreen noremoteplayback"
            controls={false}
        />
    )
}